(function () {
  if (window.cardSwatchesLoaded) return;
  window.cardSwatchesLoaded = true;

  function selectSwatch(button) {
    var wrapper = button.closest('.card-wrapper');
    var list = button.closest('.card-swatches');
    if (!wrapper || !list) return;

    list.querySelectorAll('.card-swatches__item--active').forEach(function (item) {
      item.classList.remove('card-swatches__item--active');
      item.setAttribute('aria-pressed', 'false');
    });
    button.classList.add('card-swatches__item--active');
    button.setAttribute('aria-pressed', 'true');

    var imageSrc = button.dataset.imageSrc;
    var image = wrapper.querySelector('.card__media .media img');
    if (imageSrc && image) {
      if (button.dataset.imageSrcset) image.srcset = button.dataset.imageSrcset;
      image.src = imageSrc;
      wrapper.classList.add('card-wrapper--swatch-selected');
    }

    var variantUrl = button.dataset.variantUrl;
    if (variantUrl) {
      wrapper.querySelectorAll('a.full-unstyled-link, a.card-swatches__more').forEach(function (link) {
        link.href = variantUrl;
      });
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.card-swatches__item');
    if (!button) return;
    event.preventDefault();
    selectSwatch(button);
  });

  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (event) {
      var button = event.target.closest('.card-swatches__item');
      if (!button || button.classList.contains('card-swatches__item--active')) return;
      selectSwatch(button);
    });
  }
})();
